import React from "react";

type StatusType = "primary" | "success" | "warning" | "danger" | "info";

interface ScoreCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  progress?: number | null;
  icon?: React.ReactNode;
  status?: StatusType;
}

type StatusStyles = {
  light: string;
  text: string;
  progress: string;
};
const statusConfig: Record<StatusType, StatusStyles> = {
  primary: {
    light: "bg-light-primary",
    text: "text-primary",
    progress: "bg-primary",
  },
  success: {
    light: "bg-light-success",
    text: "text-success",
    progress: "bg-success",
  },
  warning: {
    light: "bg-light-warning",
    text: "text-warning",
    progress: "bg-warning",
  },
  danger: {
    light: "bg-light-danger",
    text: "text-danger",
    progress: "bg-danger",
  },
  info:{
    light: "bg-light-info",
    text: "text-info",
    progress: "bg-info",
  }
};

const ScoreCard: React.FC<ScoreCardProps> = ({
  title,
  value,
  progress = null,
  icon,
  status = "primary",
  subtitle
}) => {
  const styles = statusConfig[status];
  const normalizedProgress =
  progress !== null
    ? Math.min(Math.max(progress, 0), 100)
    : null;

  return (
    <div className="card border border-gray-300 shadow-sm h-100">
      <div className="card-body p-2">
        <div className="d-flex align-items-center">
          {/* Icon */}
          <div
            className={`w-35px h-35px rounded-2 d-flex align-items-center justify-content-center ${styles.light}`}
          >
            <div className={styles.text}>{icon}</div>
          </div>

          {/* Content */}
          <div className="ms-4 flex-grow-1">
            {/* Title */}
            <div className="d-flex align-items-center justify-content-between">
              <span className="fw-semibold text-gray-700 fs-6">
                {title}
              </span>
              <div className={`fw-bold fs-6 ${styles.text}`}>
                  {value}
                </div>
            </div>

            {/* Progress */}
            {normalizedProgress !== null && (
              <div className="progress h-5px bg-light mt-2">
                <div
                  className={`progress-bar ${styles.progress}`}
                  role="progressbar"
                  aria-valuenow={normalizedProgress}
                  aria-valuemin={0}
                  aria-valuemax={100}
                  style={{ width: `${normalizedProgress}%` }}
                />
              </div>
            )}
            {subtitle && (
              <div className="text-muted fs-7">
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreCard;